(() => {
  const MODAL_SELECTOR = '.menu-hamburger-drawer-mobile[xo-name="xo-menu-hamburger"]';
  const TOOLBAR_SELECTOR = '[data-bdd-mobile-toolbar]';
  const TRIGGER_SELECTOR = '[data-bdd-search-browse]';

  const isMobile = () => window.matchMedia('(max-width: 767px)').matches;

  function syncDrawerState(modal) {
    if (!isMobile()) return;

    const open = modal?.hasAttribute('xo-active') && modal.getAttribute('xo-active') !== 'false';
    document.querySelectorAll(TOOLBAR_SELECTOR).forEach((toolbar) => {
      toolbar.toggleAttribute('data-bdd-drawer-open', open);
    });
    document.querySelectorAll(TRIGGER_SELECTOR).forEach((trigger) => {
      trigger.setAttribute('aria-label', open ? 'Close search and browse' : 'Search and browse');
    });

    if (!open) return;
    const input = modal.querySelector('[data-bdd-drawer-search-input]');
    if (!input) return;
    window.requestAnimationFrame(() => {
      input.focus({ preventScroll: true });
      input.select?.();
    });
  }

  function bind() {
    const modal = document.querySelector(MODAL_SELECTOR);
    if (!modal || modal.dataset.bddToolbarObserved) return;

    modal.dataset.bddToolbarObserved = 'true';
    syncDrawerState(modal);

    new MutationObserver(() => syncDrawerState(modal)).observe(modal, {
      attributes: true,
      attributeFilter: ['xo-active']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }

  document.addEventListener('shopify:section:load', bind);
})();
